export const toDataTrackIdFormat = (word: string | undefined) => {
    return word?.toLowerCase().replace(/\s/g, '-');
};
